module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jG4xJ"))).then(() => parcelRequire('iDabs'));